import LanguageDetector from 'i18next-browser-languagedetector';
import { useRef } from 'react';
import { createInstance } from 'i18next';
import { initReactI18next } from 'react-i18next';
import intervalPlural from 'i18next-intervalplural-postprocessor';
import langdomain from '@/locales/subdomainLang';
import { i18nOptions } from '@/i18n-server';
import { Languages } from '@/constants/common';

export const useClientI18n = (lng: Languages) => {
  const languageDetector = new LanguageDetector();

  languageDetector.addDetector(langdomain);

  const i18nInstance = useRef(
    createInstance()
      .use(initReactI18next)
      .use(languageDetector)
      .use(intervalPlural)
  ).current;

  if (!i18nInstance.isInitialized) {
    i18nInstance.init({
      lng,
      ...i18nOptions,
    });
  }

  return i18nInstance;
};
